import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import StaffForm from "./StaffForm";
import { addStaffApi } from "../../api/staffService";
import { getErrorMessage } from "../../utils/errorHandler";
const AddStaff = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const userId = localStorage.getItem("userId");
  const handleAdd = async (formData) => {
    try {
      setLoading(true);
      const response = await addStaffApi(formData);
      if (response?.success === false) {
        setIsError(true);
        setMessage(response?.message || "Failed to add staff");
        return;
      }
      setIsError(false);
      setMessage(response?.message || "Staff added successfully");
      setTimeout(() => {
        navigate("/staff");
      }, 1200);
    } catch (error) {
      setIsError(true);
      setMessage(getErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="container mt-4">
      {message && (
        <div className={`alert ${isError ? "alert-danger" : "alert-success"}`}>
          {message}
        </div>
      )}
      <StaffForm
        onSubmit={handleAdd}
        loading={loading}
        userId={userId}
      />
    </div>
  );
};
export default AddStaff;
